import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getGridWidthClass from '../../utils/getGridWidthClass';

import Icon from '../Icon';

const StudyListTableRow = props => {
    const { tableData } = props;
    const { row, expandedContent, onClickRow, isExpanded, dataCY } = tableData;
    return (
        <>
            <tr
                className="select-none"
                data-cy={dataCY}
            >
                <td
                    className={classnames('border-0 p-0', {
                        'border-b': isExpanded,
                    })}
                    style={isExpanded ? { borderColor: 'var(--table-border)', background: 'var(--bg-card)' } : {}}
                >
                    <div
                        className={classnames(
                            'w-full transition duration-300',
                            {
                                'mb-2 overflow-visible rounded border': isExpanded,
                            },
                            {
                                'border-transparent': !isExpanded,
                            }
                        )}
                        style={isExpanded ? { borderColor: 'var(--border-card)' } : {}}
                    >
                        <table className={classnames('w-full p-4')}>
                            <tbody>
                                <tr
                                    className={classnames(
                                        'depth-table-row cursor-pointer transition duration-300',
                                    )}
                                    onClick={onClickRow}
                                    style={{ background: 'var(--bg-card)' }}
                                >
                                    {row.map((cell, index) => {
                                        const { content, title, gridCol } = cell;
                                        return (
                                            <td
                                                key={index}
                                                className={classnames(
                                                    'truncate px-4 py-2 text-base',
                                                    { 'border-b': !isExpanded },
                                                    getGridWidthClass(gridCol) || ''
                                                )}
                                                style={{
                                                    maxWidth: 0,
                                                    borderColor: 'var(--table-border)',
                                                }}
                                                title={title}
                                            >
                                                <div className={classnames('flex', { 'ml-4': index === 0 })}>
                                                    {/* {index === 0 && (
                            <div>
                              <Icon
                                name={isExpanded ? 'chevron-down' : 'chevron-right'}
                                className="mr-4 inline-flex"
                              />
                            </div>
                          )} */}
                                                    <div
                                                        className={classnames({ 'overflow-hidden': true }, { truncate: true })}
                                                    >
                                                        {content}
                                                    </div>
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                                {isExpanded && (
                                    <tr className="max-h-0 w-full select-text overflow-hidden" style={{ background: 'var(--bg-card-inner)' }}>
                                        <td colSpan={row.length}>{expandedContent}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        </>
    );
};

StudyListTableRow.propTypes = {
    tableData: PropTypes.shape({
        /** A table row represented by an array of "cell" objects */
        row: PropTypes.arrayOf(
            PropTypes.shape({
                key: PropTypes.string.isRequired,
                /** Optional content to render in row's cell */
                content: PropTypes.node,
                /** Title attribute to use for provided content */
                title: PropTypes.string,
                gridCol: PropTypes.number.isRequired,
            })
        ).isRequired,
        expandedContent: PropTypes.node.isRequired,
        onClickRow: PropTypes.func.isRequired,
        isExpanded: PropTypes.bool.isRequired,
        dataCY: PropTypes.string,
    }),
};

export default StudyListTableRow;
